import AmexExperiential, { ComponentUnderTest } from './AmexExperiential';

export default AmexExperiential;

export {
  ComponentUnderTest,
};
